import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { handleSubmissionErrors } from '../../../utils/errors'
import Layout from '../../../layout';
import * as sidebarActions from '../../../actions/sidebar';
import * as propertyActions from '../../../actions/properties';
import * as menuActions from '../../../actions/menus';
import RestaurantMenuForm from '../../../components/RestaurantMenuForm/RestaurantMenuForm';
import FormNavigator from '../../../components/FormNavigator';

const sections = [
  { id: 'title', title: 'Title & Script' },
  { id: 'publish', title: 'Publish' },
];

class New extends Component {
  componentDidMount() {
    const {
      updateSidebar,
      fetchProperty,
      match: {
        params: { restaurantId }
      }
    } = this.props;
    fetchProperty(restaurantId).then(restaurant => {
      updateSidebar({ titles: { Restaurant: restaurant.name } });
    });
  }

  handleSubmit = data => {
    const {
      createMenu,
      match: {
        params: { restaurantId }
      },
      history: { push }
    } = this.props;
    const menu = {
      ...data
    };
    return createMenu(restaurantId, menu)
      .then(() => push(`/restaurants/${restaurantId}/menu`))
      .catch(e => {
        handleSubmissionErrors(e)
      });
  };

  render() {
    const {
      restaurant,
      match: {
        params: { restaurantId }
      }
    } = this.props;
    return (
      <Layout metaTitle="Menu">
        <div className="w-full max-w-3xl">
          <Link
            to={`/restaurants/${restaurantId}/menu`}
            className="mb-8 inline-block text-sm text-grey-dark hover:text-grey-darkest no-underline"
          >
            &lt; Back to Menu
          </Link>
          <h1 className="mb-6">New Menu</h1>
          <div className="mb-16">
            Use this page to create Menu for {restaurant.name}.
          </div>
          <RestaurantMenuForm
            id="new-menu-form"
            restaurant={restaurant}
            initialValues={{
              doesNotEnd: true,
              archived: false
            }}
            onSubmit={this.handleSubmit}
          />
        </div>
        <FormNavigator
          id="new-menu-navigator"
          sections={sections}
          className="hidden xl:block mt-32 pt-16"
        />
      </Layout>
    );
  }
}

New.propTypes = {
  updateSidebar: PropTypes.func.isRequired,
  fetchProperty: PropTypes.func.isRequired,
  createMenu: PropTypes.func.isRequired,
  restaurant: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object
};

New.defaultProps = {
  restaurant: {},
  match: {},
  history: {}
};

export default connect(
  (state) => ({
    restaurant: state.property.data,
    menus: state.menus.data,
    isLoading: state.property.isLoading
  }),
  {
    ...sidebarActions,
    ...propertyActions,
    ...menuActions
  }
)(New);
